export const NotFoundPage = () => <>
    <section className="section">
        <div className="container has-text-centered">
            <h1 className="title">NOT FOUND</h1>
            <p>Unfortunately you have tried to access a page that doesn't exist</p>
        </div>
    </section>
</>;